import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { SearchInput } from './SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalSearchMinifiedInput = _ref => {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(SearchInput, Object.assign({}, props));
};